import * as React from "react";
import { PortInput } from "../../../../schema/types/workload/input";
import { FormListFieldItem } from "../../../gvc/formListFieldItem";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { CpInputNumber } from "../../../gvc/testNewForm/CpInputNumber";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { store } from "../../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: PortInput;
  index?: number;
}
export const CpArrayItemContainerPort: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={2} hasRemoveButton className="mb-1">
      <CpSelect
        name={`${name}.${index}.protocol`}
        options={[
          { label: "HTTP", value: "http" },
          { label: "HTTP2", value: "http2" },
          { label: "GRPC", value: "grpc" },
          { label: "TCP", value: "tcp" },
        ]}
      />
      <CpInputNumber name={`${name}.${index}.number`} className="w-full free-width" />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
